import { call, put, all, select, takeEvery } from "redux-saga/effects";
import { deleteImage, deleteBoards } from "src/utils/Firebase";

import {
  setBoardId,
  getBoardDataSuccess,
  clearBoard,
  GET_BOARDDATA,
  DELETE_BOARD
} from "./actions";

export function* getBoardDataFlow(board) {
  const { data } = board;
  const boardData = {};
  let i = 0;
  Object.keys(data)
    .sort(function(a, b) {
      return b - a;
    })
    .forEach(function(key) {
      boardData[i++] = data[key];
    });
  yield put(clearBoard());
  yield put(setBoardId({ selectedId: boardData[0].id }));
  yield put(getBoardDataSuccess(Object.values(boardData)));
}
export function* deleteBoard() {
  const { board } = yield select();
  const imgFile = board.img.indexOf("jpeg")
    ? `/board${board.selectedId}.${"jpeg"}`
    : `/board${board.selectedId}.${"jpg"}`;

  yield all([call(deleteBoards, board.selectedId), call(deleteImage, imgFile)]);
}

export function* watchGetBoard() {
  yield takeEvery(GET_BOARDDATA, getBoardDataFlow);
}

export function* watchDeleteBoard() {
  yield takeEvery(DELETE_BOARD, deleteBoard);
}

export default function* boardRoot() {
  yield all([watchGetBoard(), watchDeleteBoard()]);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas.js